module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Model-Q-1141.4c7538b1.jpg";